import Snackbar from '@mui/material/Snackbar';
import { useSelector } from "react-redux";
import Alert from '@mui/material/Alert';
import { RootState } from "../../store/store";
import { useAppDispatch } from "../../store/customHooks";
import { clearNotification } from '../../redux/reducer/commonReducer';

export default function Notification(props: any) {

    const dispatch = useAppDispatch();
    const notification = useSelector((state: RootState) => state.common.notification);

    const handleClose = () => {
        dispatch(clearNotification());
    };

    return (
        <Snackbar
            open={notification.isOpen}
            autoHideDuration={2000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            onClose={handleClose}
        >
            <Alert
                elevation={6} variant="filled"
                onClose={handleClose}
                severity={notification.type}
            >
                {notification.message}
            </Alert>
        </Snackbar>);
}






